import { render, staticRenderFns } from "./CirclechartComponent.vue?vue&type=template&id=040d243c&scoped=true"
import script from "./CirclechartComponent.vue?vue&type=script&lang=js"
export * from "./CirclechartComponent.vue?vue&type=script&lang=js"
import style0 from "./CirclechartComponent.vue?vue&type=style&index=0&id=040d243c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040d243c",
  null
  
)

export default component.exports